import { useNavigate } from 'react-router-dom';
import logo from '../../../Assets/images/logo-2.jpeg';
import { FiBell, FiSearch, FiLogOut } from 'react-icons/fi';

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear all admin-related data from localStorage
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('adminAuthenticated');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Redirect to admin login page
    navigate('/admin/login');
    
    // Optional: Show success message
    console.log('Logged out successfully');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      {/* Gradient Background Bar */}
      <div className="bg-gradient-to-r from-[#FFA500] via-[#d4a72b] via-40% to-[#708238] flex justify-between items-center px-4 sm:px-6 py-4">
        {/* Left Section */}
        <div className="flex items-center">
          <img
            src={logo}
            alt="JustERPs Logo"
            className="w-48 rounded-lg mr-4 sm:mr-10 object-cover"
          />

          <div className="hidden md:flex items-center justify-between p-4 space-x-6">
            {/* Title */}
            <h1 className="text-3xl font-extrabold text-white tracking-wide drop-shadow-lg">
              ADMIN DASHBOARD
            </h1>

            {/* Search Box */}
            <div className="relative">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                className="pl-10 pr-4 py-2 w-64 border border-gray-200 rounded-lg 
                           focus:outline-none focus:ring-2 focus:ring-[#FFA500] focus:border-transparent"
              />
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-3 sm:space-x-4">
          {/* Notification Icon */}
          <button className="p-2 rounded-full bg-gradient-to-br from-[#FFA500] to-[#708238] hover:opacity-90 relative transition shadow-md">
            <FiBell className="text-white text-lg" />
            <span className="absolute top-0 right-0 h-2.5 w-2.5 rounded-full bg-red-500 border-2 border-white"></span>
          </button>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="p-2 rounded-full bg-red-500 hover:bg-red-600 transition shadow-md flex items-center gap-2 px-4"
            title="Logout"
          >
            <FiLogOut className="text-white text-lg" />
            <span className="text-white text-sm font-medium hidden sm:inline">Logout</span>
          </button>

          {/* Profile Icon */}
          <div className="h-8 w-8 rounded-full bg-gradient-to-br from-[#FFA500] to-[#708238] text-white flex items-center justify-center font-semibold cursor-pointer hover:opacity-90 shadow-md">
            A
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
